import { Tooltip } from '@bryntum/schedulerpro';
import { useEffect, useMemo } from 'react';
import { PlanningLevelConfig } from 'api/resource-management/types';
import { useTranslate } from 'hooks/use-translation';
import { useResourceManagementConfigQuery } from 'queries/resource-management-configuration';
import { SchedulerReference } from '../../types';
import { tooltipForEvent } from '../templates/tooltips';

export const useAllocationEventTooltip = (ref: SchedulerReference): void => {
  const translate = useTranslate();

  const { data: resourceManagementConfig } = useResourceManagementConfigQuery();

  const isHoursPerWeek = useMemo(
    () =>
      resourceManagementConfig?.planningLevelConfig ===
      PlanningLevelConfig.HoursPerWeek,
    [resourceManagementConfig?.planningLevelConfig],
  );

  useEffect(() => {
    const tooltip = new Tooltip({
      forSelector: '.b-sch-event.allocation .content',
      getHtml: (params) => {
        const { event } = params;
        const eventId = event.target.getAttribute('data-event-id');
        const allocationEvent =
          ref.current?.instance.eventStore.getById(eventId);

        if (allocationEvent) {
          return tooltipForEvent(
            allocationEvent,
            translate,
            {},
            isHoursPerWeek,
          );
        }

        return null;
      },
      hoverDelay: 800,
      hideDelay: 100,
      constrainTo: ref.current.instance.timeAxisSubGridElement,
    });

    return () => {
      tooltip.destroy();
    };
  }, [ref, translate, isHoursPerWeek]);
};
